import { Button, Form, Input, Space } from "antd";
import { translate } from "../../../core";
import { GlobalOutlined } from "@ant-design/icons";

export const OrderEntryPhones = () => {
  return (
    <Space.Compact>
      <Form.Item
        label={
          <span>
            <GlobalOutlined style={{ fontSize: 14 }} />
          </span>
        }
        name="customerWorkCountryCode"
        className="w-xxsmall"
      >
        <Input className="text-center" />
      </Form.Item>
      <Form.Item
        label={translate("phone")}
        name="customerWork"
        className="w-medium"
      >
        <Input />
      </Form.Item>
    </Space.Compact>
  );
};
